import React, {useState} from 'react';

import styles from './SponsorBanner.module.css';

const SponsorBanner = ({ show, tag }) => {
  if (!show)
    return null;

  const [isHidden, setIsHidden] = useState(false);

  const onClose = () => {
    if (localStorage) {
      localStorage.removeItem(tag)
      setIsHidden(true)
    }
  }

  return isHidden ? null : <div className={styles.container}>
    <div className="d-inline">
      <span className="grey font-small">Partner Product</span>
      <span className="ms-2 me-2 light-grey font-small d-none d-sm-inline">•</span>
    </div>
    <div className="d-inline">
      ✨ <b>Looking for a job?</b> Automate your search with <a className="black tr-ai-apply" href="https://aiapply.co/tiiny-host?ref=tiiny" target="_blank">aiapply.co →</a>
    </div>
    <div className="d-inline">
      <button onClick={onClose} className="transparent-button ms-md-5">
        <img className="opacity-50" src="assets/icons/cancel_black.svg" height={12}/>
      </button>
    </div>
  </div>
}

export default SponsorBanner;